<div class="modal fade create-folder-modal" id="create-album-modal" role="dialog" tabindex="-1" aria-labelledby="create-album-modal" [ngStyle]="{'display': (universalService.showCreateFolderModal) ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}" [ngClass]="[universalService.inAppWebViewOpened ? 'webview-create-folder-modal' : '' ]">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content h-90 ">
      @if (!universalService.inAppWebViewOpened) {
        <div class="modal-header">
          <button type="button" tabindex="-1" class="close btn-pos" data-dismiss="modal" (click)="closeCreateModal()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        </div>
      }
      <div class="modal-body">
        @if (universalService.inAppWebViewOpened) {
          <div (click)="closeCreateModal()">
            <button type="button" tabindex="-1" class="close btn-pos" data-dismiss="modal">
              <span class="NeueFile_Cancel"></span>
              <span class="esc">esc</span>
            </button>
          </div>
        }
        <div class="create-folder-main">
          <h2 class="mb-5" >Create folder in <strong class="jiocloudTag" >{{universalService.selectedTab=='Private Folder'?"Private Folder":"JioAICloud"}}</strong></h2>
          <!-- <h2 class="mb-4 jiocloudTag">JioAICloud</h2> -->
          <form onsubmit="return false">
            <input #folderName type="text" autofocus autocomplete="off" id="folderName" maxlength="200" value="" (keyup)="validateBeforeCreatingFolder(folderName.value)" placeholder="Folder name" />
            <div class="inputError">
              @if (this.universalService.errorMessage!='') {
                <span><i class="NeueAlert mr-1"></i>{{this.universalService.errorMessage}}</span>
              }
            </div>
            <button class="btn mt-3 mb-2  ripple-fx" (click)="createFolder(folderName.value)" [disabled]="!enableButton">{{buttonText}}</button>
          </form>
          @if (universalService.popUpToBeOpened == 'movePopUp' || universalService.popUpToBeOpened == 'copyPopUp') {
            <span class="text-center d-none d-lg-block mt-5 btn-go-back" data-dismiss="modal" (click)="goBackToPreviousScreen();folderName.value=''"><a href="javascript:void()" rel="noopener noreferrer">Go Back</a></span>
          }
        </div>
      </div>
      <div class="modal-footer border-top-0">&nbsp;</div>
    </div>
  </div>
</div>